import { useEffect, useState } from 'react';
import RestUtilities from '../../services/RestUtilities';
import { Box, Button, Typography } from '@mui/material';

import {
  loadingState,
  paginationModelState,
  toastState,
} from '../../state/RecoilState';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { Client } from '../../@types/api';
import dayjs from 'dayjs';
import { colDateFormat } from '../../Constants';

const Clients = () => {
  const navigate = useNavigate();
  const setLoading = useSetRecoilState(loadingState);
  const setToast = useSetRecoilState(toastState);
  const [paginationModel, setPaginationModel] =
    useRecoilState(paginationModelState);
  const [data, setData] = useState<Client[]>([]);

  useEffect(() => {
    const getAllData = async () => {
      setLoading(true);
      const res = await RestUtilities.get('/api/client/Get');
      setData(res.content);
      setToast('Clients Loaded');
      setLoading(false);
    };
    if (data.length === 0) {
      getAllData();
    }
  }, [data, setLoading, setToast]);

  return (
    <Box>
      <Box my={1} display='flex' justifyContent={'space-between'}>
        <Typography variant='h5'>Clients</Typography>
      </Box>
      <DataGrid
        rows={data}
        columns={
          [
            {
              headerName: 'Client ID',
              field: 'clientId',
              sortable: true,
              renderCell: (params) => (
                <Button
                  onClick={(event) =>
                    navigate(`/client/edit/${params.row.clientId}`)
                  }
                  size='small'
                  variant='contained'
                  sx={{ my: 3 }}
                  color='primary'
                >
                  {params.row.clientId}
                </Button>
              ),
            },
            {
              headerName: 'First Name',
              field: 'firstName',
              width: 150,
            },
            {
              headerName: 'Surname',
              field: 'surname',
              width: 150,
            },
            {
              headerName: 'Email',
              field: 'emailAddress',
              width: 250,
            },
            {
              headerName: 'Phone',
              field: 'mobile',
              width: 150,
              sortable: false,
            },
            {
              headerName: 'Last Updated',
              field: 'lastUpdateWhen',
              sortable: false,
              valueFormatter: (params) =>
                dayjs(params.value).format(colDateFormat),
            },
          ] as GridColDef[]
        }
        getRowId={(row) => row.clientId}
        pageSizeOptions={[25, 50, 100, 250]}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
      />
    </Box>
  );
};
export default Clients;
